module.exports = __webpack_public_path__ + "media/question1_au.5bbb713b.mp3";